<div class="column has-text-centered row">
  <div class="col-sm" *ngFor="let image of _albums; let i=index">
    <ng-container [ngSwitch]="imageExtensions.indexOf(image.thumb.split('.').pop().toLowerCase())">
      <i *ngSwitchCase='-1' class="img-frame fas fa-file" (click)="open_tab(i)"></i>
      <img *ngSwitchDefault class="img-frame " [src]="image.thumb" (click)="open(i)" />
    </ng-container>
  </div>
</div>
